import React, { useCallback, PureComponent } from 'react';
import monsterNames from '../data/names';
import breeding from '../data/breeding';
import breedingPlus from '../data/breedingPlus';
import monsterImages from '../data/photoList';
import { get, throttle } from 'lodash';

class BasicCellRenderer extends PureComponent {
  render() {
    return (
      <div style={{ ...this.props.style, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {this.props.data || `${this.props.row || '?'},${this.props.column || '?'}`}
      </div>
    );
  }
}

export default class FixedHeaderTable extends React.Component {
  // componentDidMount() {
  //   window.addEventListener('scroll', this.handleScroll);
  // }
  // componentWillUnmount() {
  //   window.removeEventListener('scroll', this.handleScroll);
  // }
  constructor(props) {
    super(props);

    this.throttledHandleScroll = throttle(this.handleScroll, 10);
    this.state = {};
  }
  handleScroll = (event) => {
    if (!event.target || event.target !== this.mainContainer) return null;
    const scrollTop = event.target.scrollTop;
    const scrollLeft = event.target.scrollLeft;
    // const itemTranslate = Math.min(0, scrollTop / 3 - 60);

    const totalColumns = this.getColumnCount();
    const totalRows = this.getRowCount();

    const left = scrollLeft
    const right = scrollLeft + event.target.clientWidth;
    const startingColumn = Math.floor(left / this.props.cellWidth);
    const visibleColumns = Math.ceil((right - left) / this.props.cellWidth) + 1;
    const invisibleColumns = totalColumns - (startingColumn + visibleColumns);

    const top = scrollTop
    const bottom = scrollTop + event.target.clientHeight;
    const startingRow = Math.floor(top / this.props.cellHeight);
    const visibleRows = Math.ceil((bottom - top) / this.props.cellHeight) + 1;
    const invisibleRows = totalRows - (startingRow + visibleRows);

    const viewOffsetLeft = Math.round(left) % this.props.cellWidth;
    const viewPaddingLeft = (startingColumn * this.props.cellWidth) - viewOffsetLeft;
    const viewPaddingRight = invisibleColumns * this.props.cellWidth;
    const viewPaddingBottom = invisibleRows * this.props.cellHeight;
    const viewOffsetTop = Math.round(top) % this.props.cellHeight;
    const viewPaddingTop = (startingRow * this.props.cellHeight) - viewOffsetTop;

    this.setState({
      startingColumn,
      visibleColumns,
      startingRow,
      visibleRows,
      invisibleColumns,
      invisibleRows,
      viewPaddingLeft,
      viewPaddingRight,
      viewPaddingBottom,
      viewPaddingTop,
      scrollLeft,
      scrollTop,
    });
  }
  getRowCount = () => {
    return get(this, ['props', 'leftHeaders', 'length']) || 0;
  }
  getColumnCount = () => {
    return get(this, ['props', 'topHeaders', 'length']) || 0;
  }
  getData = (column, row) => {
    return get(this, ['props', 'data', row, column]);
  }
  getTopHeaderData = (column) => {
    return get(this, ['props', 'topHeaders', column]);
  }
  getLeftHeaderData = (row) => {
    return get(this, ['props', 'leftHeaders', row]);
  }
  refMainContainer = (mainContainer) => {
    const firstrender = !this.mainContainer;
    this.mainContainer = mainContainer;
    if (firstrender) {
      this.handleScroll({ target: this.mainContainer });
    }
  }
  renderRow(row) {
    const { cellRenderer, cellHeight, cellWidth } = this.props;
    const columns = this.getColumnCount();
    const cellStyle = {
      flex: `0 0 ${cellWidth}px`,
    };
    const result = [];
    const Renderer = cellRenderer || BasicCellRenderer;
    for (let column = 0; column < columns; column++) {
      result.push(
        <Renderer
          data={this.getData(column, row)}
          rowData={this.getLeftHeaderData(row)}
          columnData={this.getTopHeaderData(column)}
          style={cellStyle}
          width={cellWidth}
          height={cellHeight}
          row={row}
          column={column}
        />
      );
    }
    return (
      <div style={{ display: 'flex', flexDirection: 'row', height: cellHeight, paddingLeft: cellWidth }}>
        {result}
      </div>
    );
  }

  renderTopHeader() {
    const { topHeaderRenderer, cellHeight, cellWidth } = this.props;
    const { startingColumn, visibleColumns } = this.state;
    const columns = this.getColumnCount();

    const Renderer = topHeaderRenderer || BasicCellRenderer;
    const headers = [];
    // const headerStyle = {
    //   flex: `0 0 ${cellWidth}px`,
    //   width: cellWidth,
    //   height: cellHeight,
    //   backgroundColor: '#eee',
    //   // boxShadow: '0 0 10px #555',
    // };

    // for (let column = 0; column < columns; column++) {
    //   headers.push(<Renderer data={this.getTopHeaderData(column)} column={column} style={headerStyle} key={`header_${column}`} />);
    // }

    for (let column = Math.max(startingColumn - 1, 0); column < Math.min(startingColumn + visibleColumns, columns); column++) {
      headers.push(
        <Renderer
          data={this.getTopHeaderData(column)}
          column={column}
          style={{
            position: 'absolute',
            top: 0,
            left: column * cellWidth + cellWidth,
            height: cellHeight,
            width: cellWidth,
            backgroundColor: '#eee',
          }}
          key={`column_header_${column}`}
        />
      );
    }

    return (
      <div style={{ position: 'sticky', display: 'flex', flexDirection: 'row', top: 0, zIndex: 4, height: cellHeight, width: cellWidth * (columns + 1), boxShadow: '0 0 10px #555' }}>
        <div onClick={this.clickBlank} style={{ flex: `0 0 ${cellWidth}px`, width: cellWidth, height: cellHeight,  display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}></div>
        {headers}
      </div>
    );
  }
  renderLeftHeader() {
    const { leftHeaderRenderer, cellHeight, cellWidth } = this.props;
    const { startingRow, visibleRows } = this.state;
    const rows = this.getRowCount();

    const Renderer = leftHeaderRenderer || BasicCellRenderer;
    const headers = [];
    const headerStyle = {
      flex: `0 0 ${cellHeight}px`,
      height: cellHeight,
      width: cellWidth,
      backgroundColor: '#eee',
      // boxShadow: '0 0 10px #555',
    };

    for (let row = startingRow; row < Math.min(startingRow + visibleRows, rows); row++) {
      headers.push(
        <Renderer
          data={this.getLeftHeaderData(row)}
          row={row}
          style={{
            position: 'absolute',
            left: 0,
            top: row * cellHeight,
            height: cellHeight,
            width: cellWidth,
            backgroundColor: '#eee',
          }}
          key={`row_header_${row}`}
        />
      );
    }

    return (
      <div style={{ position: 'sticky', display: 'flex', flexDirection: 'column', left: 0, zIndex: 3 }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: cellWidth, height: cellHeight * this.getRowCount(), display: 'flex', flexDirection: 'column', boxShadow: '0 0 10px #555' }}>
          {headers}
        </div>
      </div>
    );
  }

  renderVisible() {
    const { cellRenderer, cellWidth, cellHeight } = this.props;
    const { startingColumn, startingRow, visibleColumns, visibleRows } = this.state;

    const visible = [];
    const leftOffset = 0;
    const topOffset = 0;
    const Renderer = cellRenderer || BasicCellRenderer;

    for (let column = startingColumn; column < Math.min(startingColumn + visibleColumns, this.getColumnCount()); column += 1) {
      for (let row = startingRow; row < Math.min(startingRow + visibleRows, this.getRowCount()); row += 1) {
        visible.push(
          <div key={`${column},${row}`} style={{ position: 'absolute', left: column * cellWidth + leftOffset, top: row * cellHeight + topOffset, width: cellWidth, height: cellHeight }}>
            <Renderer
              data={this.getData(column, row)}
              rowData={this.getLeftHeaderData(row)}
              columnData={this.getTopHeaderData(column)}
              width={cellWidth}
              height={cellHeight}
              row={row}
              column={column}
            />
          </div>
        )
      }
    }

    return (
      <div style={{ width: this.getColumnCount() * this.props.cellWidth, height: this.getRowCount() * this.props.cellHeight, marginLeft: this.props.cellWidth }}>
        {visible}
      </div>
    );
  }

  renderContent() {
    const rows = [];
    for (let row = 0; row < this.getRowCount(); row += 1) {
      rows.push(this.renderRow(row));
    }
    return (
      <div style={{ zIndex: 2 }}>
        {rows}
      </div>
    );
  }

  render() {
    const { style } = this.props;


    return (
      <div ref={this.refMainContainer} onScroll={this.handleScroll} style={style ? Object.assign({}, styles.container, style) : styles.container}>
        {this.renderTopHeader()}
        {this.renderLeftHeader()}
        {this.renderVisible()}
      </div>
    );
  }
}

const styles = {
  container: {
    overflow: 'auto',
    height: '100%',
    width: '100%',
  }
};
